import { IonText, IonGrid, IonRow, IonCol, IonImg } from "@ionic/react";

import "./TaskSelectionOptionCore2.css";

import "../../Fonts.css";
import TaskSelectionOptionHint from "../task_selection_option_hint/TaskSelectionOptionHint";
import { DataSubmissionService } from "../../services/DataSubmissionService";

interface TaskSelectionOptionCore2Props {
  index: number;
  imageUrl: string;
  title: string;
  subtitle: string;
  desc: string;
  options: any;
  isOpen: boolean;
  isSelected: Function;
  click: Function;
}

const TaskSelectionOptionCore2: React.FC<TaskSelectionOptionCore2Props> = ({
  index,
  title,
  subtitle,
  imageUrl,
  desc,
  options,
  isOpen,
  isSelected,
  click,
}) => {
  const selected = () => {
    DataSubmissionService.chooseAGoalOptionMainQuestionIndex = index;
    isSelected(index);
  };

  const optionSelected = (options: any) => {
    click(options);
  };

  return (
    <div className="acceMainContainer tsoMainContainer animate__animated animate__fadeInRight ">
      <IonGrid>
        <IonRow>
          {imageUrl !== null &&
            imageUrl !== undefined &&
            imageUrl.length > 0 && (
              <IonCol size="auto" className="tsoImgCol">
                {isOpen && (
                  <IonImg
                    src="assets/icons/RadioSelected.png"
                    onClick={selected}
                  />
                )}
                {!isOpen && (
                  <IonImg src="assets/icons/Radio.png" onClick={selected} />
                )}
              </IonCol>
            )}
          <IonCol
            className="acceTitleCol accqTitleCol"
            style={{
              paddingLeft:
                imageUrl !== null &&
                imageUrl !== undefined &&
                imageUrl.length > 0
                  ? "16px"
                  : "0px",
            }}
          >
            <IonGrid>
              <IonRow>
                {imageUrl !== null &&
                  imageUrl !== undefined &&
                  imageUrl.length > 0 && (
                    <IonCol size="auto">
                      <IonImg className="tsoMainImg" src={imageUrl} />
                    </IonCol>
                  )}
                {/* <IonCol className="tsoTitleCol">
                  <IonText className="tsoTitleText">{title}</IonText>
                </IonCol> */}
                <IonCol
                  className={
                    imageUrl !== null &&
                    imageUrl !== undefined &&
                    imageUrl.length > 0
                      ? "tsoTitleCol"
                      : ""
                  }
                >
                  <IonGrid>
                    <IonRow>
                      <IonCol>
                        <IonText className="tsoTitleText">{title}</IonText>
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        <IonText className="tsoSubTitleText">
                          {subtitle}
                        </IonText>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCol>
              </IonRow>
              {isOpen && (
                <IonRow>
                  <IonCol className="tsoDescCol" size="12">
                    <IonText className="tsoDescText" dangerouslySetInnerHTML={{ __html: desc }}></IonText>f
                  </IonCol>
                </IonRow>
              )}
              {isOpen && (
                <IonRow>
                  {options.map((option: any, i: number) => {
                    return (
                      <IonCol
                        size="12"
                        onClick={() => {
                          optionSelected(option.activitySubOptions);
                        }}
                      >
                        <TaskSelectionOptionHint
                          text={option.text}
                          imageUrl={option.imageUrl}
                          isFullWidth={false}
                          defaultSpacingTop={true}
                        />
                      </IonCol>
                    );
                  })}
                </IonRow>
              )}
            </IonGrid>
          </IonCol>
        </IonRow>
      </IonGrid>
      {/* {isOpen && (
        <div>
          {options.map((option: any, i: any) => {
            return (
              <CoreChapterActivityOptionHint
                text={option.text}
                isWhiteBG={true}
              />
            );
          })}
        </div>
      )} */}
    </div>
  );
};

export default TaskSelectionOptionCore2;
